export default "__VITE_ASSET__CA7Y9yNC__"